import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import {RoundPipe} from '../gerais';

import 'chartjs-plugin-datalabels';

import {BsModalRef} from 'ngx-bootstrap/modal';
import {BsDatepickerModule, BsDropdownModule, ModalModule, TabsModule, PopoverModule} from 'ngx-bootstrap';
import {MyDatePickerModule} from 'mydatepicker';
import {AlertModule} from 'ngx-alerts';
import {NgxLoadingModule} from 'ngx-loading';
import {NguiAutoCompleteModule} from '@ngui/auto-complete';
import {ChartsModule} from 'ng2-charts/ng2-charts';
import {NgxDatatableModule} from '@swimlane/ngx-datatable';
import {WebStorageModule} from 'ngx-store';
import {ClipboardModule} from 'ngx-clipboard';
import {FileUploadModule} from 'ng2-file-upload';

import {CidadesComponent, LoaderComponent, AlertComponent} from '../gerais';
import {FormUsuarioComponent} from '../pages/gestao/usuarios';
import {AlertaEmailComponent} from '../pages/gestao/usuarios/alerta-email/alerta-email.component';

import {WsTerceiros, WsSpa, Funcoes} from '../services';

import {defineLocale} from 'ngx-bootstrap';
import {ptBrLocale} from 'ngx-bootstrap/locale';

defineLocale('br', ptBrLocale);

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ModalModule.forRoot(),
    BsDropdownModule.forRoot(),
    PopoverModule.forRoot(),
    BsDatepickerModule.forRoot(),
    TabsModule.forRoot(),
    AlertModule.forRoot({maxMessages: 5, timeout: 5000}),
    ChartsModule,
    ClipboardModule,
    MyDatePickerModule,
    NgxDatatableModule,
    NgxLoadingModule,
    NguiAutoCompleteModule,
    WebStorageModule,
    FileUploadModule
  ],
  declarations: [
    CidadesComponent,
    LoaderComponent,
    AlertComponent,
    FormUsuarioComponent,
    AlertaEmailComponent,
    RoundPipe
  ],
  exports: [
    CidadesComponent,
    LoaderComponent,
    AlertComponent,
    FormUsuarioComponent,
    AlertaEmailComponent,
    ChartsModule,
    ModalModule,
    BsDropdownModule,
    ClipboardModule,
    PopoverModule,
    TabsModule,
    MyDatePickerModule,
    NgxDatatableModule,
    AlertModule,
    NgxLoadingModule,
    NguiAutoCompleteModule,
    BsDatepickerModule,
    WebStorageModule,
    FileUploadModule,
    RoundPipe
  ],
  providers: [
    WsTerceiros,
    WsSpa,
    Funcoes,
    BsModalRef
  ],
  entryComponents: [
    FormUsuarioComponent,
    AlertaEmailComponent
  ]
})
export class SharedModule {
}
